import { render, staticRenderFns } from "./SupplierBrandMaintenance.vue?vue&type=template&id=a889850a&scoped=true&"
import script from "./SupplierBrandMaintenance.vue?vue&type=script&lang=js&"
export * from "./SupplierBrandMaintenance.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a889850a",
  null
  
)

export default component.exports